import { Header, withLayout } from '@/components';
import { CompanyMoneyBackGuarantee } from '@/components/company/CompanyMoneyBackGuarantee';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="返金保証について" />
      <Header />
      <CompanyMoneyBackGuarantee />
    </>,
  );
};

export default Page;
